<template>
  <form
    class="new-pay3__lesson-form"
    :class="{ 'new-pay3__extra-class': extraClass }"
    ref="lessonForm"
  >
    <div class="new-pay3__form-content">
      <div class="new-pay3__form-basic-info">
        <div class="new-pay3__form-item new-pay3__grade-subject">
          <select
            class="new-pay3__form-item--content new-pay3__grade"
            v-model="weakGrade"
            ref="grade"
          >
            <option
              :value="value"
              v-for="{ label, value } in subjectGrade"
              :key="value"
            >
              {{ label }}
            </option>
          </select>
          <select
            class="new-pay3__form-item--content new-pay3__subject"
            v-model="weakSubject"
            ref="subject"
          >
            <option
              :value="value"
              v-for="{ label, value } in weakSubjectArr"
              :key="value"
            >
              {{ label }}
            </option>
          </select>
        </div>

        <div class="new-pay3__form-item">
          <input
            type="text"
            placeholder="請輸入孩子的姓名"
            class="new-pay3__form-item--content new-pay3__username"
            :class="{ alert: userNameAlert }"
            v-model="userName"
          />
        </div>
        <div class="new-pay3__form-item">
          <span class="area-code" @click="showCountry = true"
            >+{{ areaCode }}</span
          >
          <input
            type="number"
            placeholder="請輸入上課聯系手機號"
            :class="{ alert: mobileAlert }"
            class="new-pay3__tel new-pay3__form-item--content"
            v-model="mobile"
            maxlength="11"
          />
        </div>
        <div class="new-pay3__form-item">
          <input
            type="number"
            v-model="codeNumber"
            placeholder="請輸入驗證碼"
            class="new-pay3__codeNumber new-pay3__form-item--content"
          />
          <div class="new-pay3__send-code" @click.stop="identifySubmitBtn()">
            {{ codeCountDown }}
          </div>
        </div>
      </div>
    </div>

    <img
      class="new-pay3__zm-btn"
      href="javascript:;"
      src="https://web-data.zmlearn.com/image/qZgnz959RqEdhRGmfLwj7k/%E9%A2%86%E5%8F%96%E6%8C%89%E9%92%AE%402x.png"
      @click="handleSubmitBtn()"
    />

    <div class="new-pay3__form-protocol">
      <img
        :src="getCheckedIcon"
        @click="checkProtocol = !checkProtocol"
        class="new-pay3__checkoutImg"
        alt
      />
      <div>
        <span
          @click="checkProtocol = !checkProtocol"
          class="new-pay3__form-protocol--text"
          >我已閱讀並同意
        </span>
        <span
          @click.stop="showProtocol('1')"
          class="new-pay3__form-protocol--high-light"
          >《用戶協議》
        </span>
        和
        <span
          @click.stop="showProtocol('2')"
          class="new-pay3__form-protocol--high-light"
          >《隱私政策》
        </span>
      </div>
    </div>
    <div class="new-pay3__info">
      <img
        class="new-pay3__lock"
        src="https://web-data.zmlearn.com/image/vRuqLVCMvKdxPdhcoQBoCv/%E5%BD%A2%E7%8A%B6.png"
      />
      <span>為了您的權益，您的隱私將被嚴格保密</span>
    </div>

    <div :class="{ 'mask-box': true }" v-if="showMask">
      <div class="verification-box">
        <img
          src="https://static-app-manager.zmlearn.com/iCAIDA-d4998.png"
          @click="hideMask()"
          class="closeIcon"
          alt
        />
        <div class="phone-text">
          验证码已发送至{{ mobile | filterPhoneNumber }}
        </div>
        <div class="code-box">
          <input type="number" v-model="codeNumber" class="codeNumber" />
          <div class="send-code" @click.stop="identifySubmitBtn()">
            {{ codeCountDown }}
          </div>
        </div>
        <div class="verification-btn" @click="checkBtn()">
          最后一步，立即领取
        </div>
        <div class="bottom-title">领取后课程规划师会与您电话沟通课程详情</div>
      </div>
    </div>
    <fail-dialog ref="failDialog"></fail-dialog>
    <country v-model="showCountry" @select="areaCode = $event"></country>
  </form>
</template>

<script>
import api from "@/api";
import cookies from 'js-cookie';
import {
  request,
  queryObj,
  isEmptyObject,
} from "@/utils/util";
import urlConfig from "@/config";
import failDialog from "@/components/fail-dialog/fail-dialog";
import Toast from "@/base/toast/toast";
import BindForm from "@/components/bindForm/index";
import BindFormComponent from "@/components/bindForm/create";
import country from '../country-traditional/index.vue';

import {
  mapState
} from "vuex";


const FROM_DICT = {

  "3": {
    trigger_site: "弹窗立即购买",
    event_id: "click_kid_act_19.9_ljgm02",
    event_name: "点击|少儿|官网m端|弹窗立即购买",
    position: "弹窗立即购买",
  },
};

export default {
  name: "lesson-form",
  components: {
    failDialog,
    country,
  },
  props: {
    'type': {
      type: String
    },
    'extraClass': {
      default: false,
      type: Boolean
    },
    'point': {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      getCode: "獲取驗證碼",
      codeCountDownNum: 60,
      codeCountSubmitNum: 3,
      areaCode: 86,
      showCountry: false,
      vertifyOnOff: true, // 获取验证码按钮是否可点击
      userName: "",
      weakGrade: "小三",
      weakSubject: "数理逻辑训练",
      mobile: "",
      userNameAlert: false,
      mobileAlert: false,
      checkProtocol: false,
      open_id: "",
      showMask: false,
      codeNumber: "",
      changMobile: false,
      subjectGrade: [
        { "label": "幼兒園小班", "value": "幼儿园小班" },
        { "label": "幼兒園中班", "value": "幼儿园中班" },
        { "label": "幼兒園大班", "value": "幼儿园大班" },
        { "label": "壹年級", "value": "小一" },
        { "label": "二年級", "value": "小二" },
        { "label": "三年級", "value": "小三" }
      ],
      weakSubjectArr: [
        { "label": "語文思維訓練", "value": "语文思维训练" },
        { "label": "數理邏輯訓練", "value": "数理逻辑训练" }
      ],
      iconCheckState: {
        checked: 'https://web-data.zmlearn.com/image/ut7ZfqyGo5aSiWmLPWCdCr/%E7%BC%96%E7%BB%84%205.png',
        unchecked: 'https://web-data.zmlearn.com/image/7cCwbkGdtrLweuC3eEEHSw/%E6%A4%AD%E5%9C%86%E5%BD%A2.png'
      },
      isSubmitting: false,
    };
  },
  filters: {
    filterPhoneNumber (number) {
      if (number.length === 11) {
        let pat = /(\d{3})\d*(\d{4})/;
        return (number = number.replace(pat, "$1****$2"));
      }
    },
  },
  watch: {
    userName () {
      this.userNameAlert = false;
    },
    mobile () {
      this.mobileAlert = false;
      this.changMobile = true;
    },
  },
  created () {
    if (this.type === 'chinese') {
      this.weakSubject = '语文思维训练'
    }
  },
  mounted () {

    this.open_id = this.urlQueryObj.open_id;
    // this.isWX = navigator.userAgent.toLowerCase().match(/MicroMessenger/i) === "micromessenger";
  },
  computed: {
    ...mapState([
      "subjectToLabel",
      "urlQueryObj",
      "subjectData"
    ]),
    codeCountDown () {
      if (this.codeCountDownNum === 60 || this.codeCountDownNum <= 0) {
        return this.getCode;
      } else {
        return this.codeCountDownNum + "s";
      }
    },
    getCheckedIcon () {
      const { checked, unchecked } = this.iconCheckState;
      return this.checkProtocol && checked || unchecked;
    },
  },

  methods: {
    showProtocol (type) {
      console.log(type, 'showProtocol')
      this.$router.push({
        name: 'agreement',
        query: {
          type
        }
      })
    },
    hideMask () {
      this.showMask = false;
    },
    // 验证码发送成功并开始倒计时
    codeSendSuccess () {
      Toast("驗證碼發送成功");
      const timer = setInterval(() => {
        this.codeCountDownNum--;
        if (this.codeCountDownNum <= 0 || this.changMobile) {
          clearInterval(timer);
          this.vertifyOnOff = true;
          this.codeCountDownNum = 60;
          this.codeNumber = "";
        }
      }, 1000);
    },
    // 发送验证码 验证码发送并倒计时
    async identifySubmitBtn () {
      if (!/^\d+$/.test(this.mobile)) {
        return Toast("請輸入手機號");
      }
      if (this.vertifyOnOff) {
        this.vertifyOnOff = false;
        try {
          const data = { mobile: this.mobile, codeType: 4, areaCode: this.areaCode + '' };
          const { data: { code, message } } = await api.sendVerifierNew(data);
          if (code * 1 === 0) {
            this.changMobile = false;
            this.codeSendSuccess();
          } else {
            this.vertifyOnOff = true;
            Toast(message || "驗證碼發送失敗，請稍後再試");
          }
        } catch (e) {
          this.vertifyOnOff = true;
          Toast(e);
        }
      }
    },

    // 验证表单
    validateForm () {
      return new Promise((resolve, reject) => {
        if (!/^([a-zA-Z]|[\u4e00-\u9fa5]){1,}$/.test(this.userName)) {
          this.userNameAlert = true;
          reject("請填寫正確的孩子姓名");
        } else if (this.userName.length >= 7) {
          this.userNameAlert = true;
          reject("請填寫正確的孩子姓名");
        } else if (this.mobile.length === 0) {
          this.mobileAlert = true;
          reject("請輸入手機號");
        } else if (
          !/^\d+$/.test(this.codeNumber)
        ) {
          reject("請輸入正確的驗證碼");
        } else if (!this.checkProtocol) {
          reject("請勾選用戶協議和隱私政策");
        } else {
          resolve("success");
        }
      });
    },

    // 埋点
    doTrack (position) {
      if (ZM_JSSDK) {
        let eventData = {
          eventId: position.event_id,
          eventParam: {
            name: position.event_name,
            grade: this.weakGrade,
            subject: this.weakSubject,
            trigger_site: position.trigger_site,
            position: position.position
          },
        };
        ZM_JSSDK.sendEvent(eventData);
      }
    },

    // 验证表单并注册
    async handleSubmitBtn () {
      ZM_JSSDK &&
        ZM_JSSDK.sendEvent({
          eventId: this.type === 'math' ? 'click_kid_act30_ljlq02' : 'click_kid_act31_ljlq02',
          eventParam: {
            code: this.$route.query.channel_code,
          }
        });
      if (this.isSubmitting) { return; }
      this.isSubmitting = true;
      try {
        await this.validateForm();
        await this.doRegister();
      } catch (e) {
        Toast(e);
      } finally {
        this.isSubmitting = false;
      }
    },

    // 注册
    async doRegister () {
      try {
        const res = await api.appoint2({
          areaCode: this.areaCode,
          name: this.userName,
          stuGrade: this.weakGrade,
          weakSubject: this.weakSubject,
          mobile: this.mobile,
          checkCodeFlag: true,
          comeFrom: this.$route.name,
          identifyingCode: this.codeNumber,
          code: this.$route.query.channel_code || "",
          key: this.$route.query.channel_keyword || "",
        })
        if (res.code * 1 === 0) {
          ZM_JSSDK &&
            ZM_JSSDK.sendEvent({
              eventId: this.type === 'math' ? 'enter_kid_act30_success' : 'enter_kid_act31_success',
              eventParam: {
                phone_num: `${this.areaCode}-${this.mobile}`,
                code: this.$route.query.channel_code,
              }
            });
          const { fbq, gtag, snaptr } = window
          fbq && fbq('track', 'Lead');
          if (window.location.pathname === '/oversea-chinese-fan') {
            gtag('event', 'conversion', { 'send_to': 'AW-444821880/ioKMCLKA2fABEPjijdQB' });
          }
          if (window.location.pathname === '/oversea-math-fan') {
            gtag('event', 'conversion', { 'send_to': 'AW-444821880/IbnACLrG5vABEPjijdQB' });
          }
          gtag && gtag('event', 'conversion', { 'send_to': 'AW-600839676/AtU-CPruwNwBEPyrwJ4C' });
          gtag && gtag('event', 'conversion', { 'send_to': 'AW-465936768/bOk6CM32m-wBEIDDlt4B' });
          snaptr && snaptr('track', 'PAGE_VIEW');
          this.$router.push({
            name: this.areaCode === 86 ? 'appointment-success-kid' : 'appointment-success-kid-not86',
            params: {
              mobile: this.areaCode === 86 ? this.mobile : `${this.areaCode}-${this.mobile}`,
              flatfrom: this.$route.name || '',
              grade: this.weakGrade,
              channel_code: this.$route.query.channel_code,
              channel_keyword: this.$route.query.channel_code,
              showPeilian: false,
              from: window.location.pathname
            },
          });
        } else {
          Toast(res.message);
        }
      } catch (e) {
        Toast(e);
      }
    },

    // 跳转支付
    goToPay (token, code, key) {
      const redirectUrl = encodeURIComponent(location.href + '&paid=1');
      // window.location.href = `${urlConfig.zminet}/learningCenter/wechatAuth?redirect_url=${redirectUrl}`
      window.location.href = `${urlConfig.marketingZmtest}/equity_sell?bu=2&saleId=${urlConfig.newPay3SaleId}&channel_code=${code || 1}&channel_keyword=${key || 1}&routeName=orderConfirm&token=${token}&redirect_url=${redirectUrl}`;
    },

    // QQ广点通
    // 微信朋友圈
    async submitAdData (accessToken) {
      try {
        const { gdt_vid = '', channel_code = '', qz_gdt = '' } = this.$route.query;
        const params = {
          actionType: "RESERVATION", // RESERVATION-注册 COMPLETE_ORDER-下单
          clickId: qz_gdt || gdt_vid,
          source: channel_code,
          url: location.href,
          value: 0
        };
        if (gdt_vid) {
          let weChatData = params;
          if (!channel_code) {
            weChatData = { ...params, source: '21035' }
          }
          await api.submitDataForWeChatAdData(weChatData)
        } else {
          let qqData = params;
          if (!channel_code) {
            qqData = { ...params, source: '21020' };
          }
          await api.submitDataForGDT(qqData);
        }
      } catch (e) {
        console.log(e);
      } finally {
        const { channel_code = '', channel_keyword = '' } = this.$route.query;
        this.goToPay(accessToken, channel_code, channel_keyword);
      }
    },

  },
};
</script>

<style lang="scss" scoped>
$theme: #ff6e35;
$fz-protocol: px2rem(22);
$bgColor: #fff;
$black0: #000;
$black3: #333;
$black6: #666;
$black9: #999;
$space: px2rem(14);
.area-code {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-right: px2rem(7);
  border-radius: px2rem(20);
  padding-left: px2rem(19);
  width: px2rem(126);
  height: px2rem(86);
  background: #eeeeee;
  font-size: px2rem(28);
  color: #999999;
  box-sizing: border-box;
}
@mixin utils-flex(
  $align-item: center,
  $justify-content: center,
  $direction: row,
  $wrap: nowrap
) {
  display: flex;
  align-items: $align-item;
  justify-content: $justify-content;
  flex-flow: $direction $wrap;
}
.new-pay3 {
  &__lesson-form {
    overflow: hidden;
    width: px2rem(688);
    height: px2rem(886);
    background: url('https://web-data.zmlearn.com/image/o8vjhdUyG55vyRBrfmNamJ/bg%403x.png')
      no-repeat px2rem(-12) 0 / cover;
  }
  &__extra-class {
    position: absolute;
    bottom: -20px;
    background: none;
    .new-pay3__form-content {
      margin-top: 50px;
    }
    .new-pay3__zm-btn {
      // visibility: hidden ;
    }
    .new-pay3__send-code {
      right: px2rem(50);
    }
  }
  &__form-content {
    margin-top: px2rem(178);
  }
  &__form-item {
    width: 100%;
    padding: 0 px2rem(32) px2rem(16);
    box-sizing: border-box;
    @include utils-flex;
    &--content {
      width: 100%;
      height: px2rem(86);
      padding: 0 px2rem(20);
      border-radius: px2rem(20);
      border: none;
      box-sizing: border-box;
      color: #202020;
      background: #eee;
      font-size: px2rem(28);

      &::placeholder {
        color: #999;
      }
    }
  }
  &__grade-subject {
    justify-content: space-between;
  }
  &__grade,
  &__subject {
    position: relative;
    width: 48%;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: url('https://web-data.zmlearn.com/image/8kzGTUynStSU5ZM1u8uSqm/arrow_03.png')
      no-repeat 90% center transparent;
    background-size: px2rem(26) px2rem(16);
    background-color: #eee;
    padding: 0 px2rem(30) 0 px2rem(20);
    font-size: px2rem(28);
  }
  &__title {
    font-size: px2rem(55);
    padding: px2rem(40);
    color: $theme;
  }
  &__send-code {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: px2rem(74);
    border-radius: px2rem(10);
    width: px2rem(181);
    height: px2rem(66);
    background: #ff7533;
    font-size: px2rem(28);
    color: #fff;
  }
  &__form-protocol {
    @include utils-flex;
    &--text {
      font-size: $fz-protocol;
      color: #2b2b2b;
    }
    &--high-light {
      font-size: $fz-protocol;
    }
    &--high-light {
      color: $theme;
    }
  }
  &__checkoutImg {
    width: px2rem(26);
    margin-right: $space;
  }
  &__lock {
    width: px2rem(18);
    margin-right: $space;
  }
  &__info {
    margin-top: px2rem(20);
    color: #575757;
  }
  &__zm-btn {
    width: px2rem(634);
    height: px2rem(138);
  }
}
</style>